import React, { useContext } from "react";
import {
  ActionButton,
  HotelPriceAndRewardsDisplay,
  CorpPolicyBanner,
} from "halifax";
import { RouteComponentProps } from "react-router-dom";
import { MobileListingTotalPanelConnectorProps } from "./container";
import { Box, Typography } from "@material-ui/core";
import "./styles.scss";
import * as textConstants from "./textConstants";
import clsx from "clsx";
import { goToVacationRentalsCheckout } from "../../../shop/utils/queryStringHelpers";
import { ShopErrorCta } from "../ShopErrorCta";
import { IShopErrorCtaVariant } from "../ShopErrorCta/component";
import { ShopErrorButton } from "../ShopErrorButton";
import { useShowPolicyBanner, isCorpTenant } from "@capone/common";
import { ClientContext } from "../../../../App";
import { config } from "../../../../api/config";
export interface MobileListingTotalPanelProps
  extends MobileListingTotalPanelConnectorProps,
    RouteComponentProps {
  isSkeleton?: boolean;
}

export const MobileListingTotalPanel = (
  props: MobileListingTotalPanelProps
) => {
  const { nightCount, isSkeleton, rewardsKey, listing, history, listPrice } =
    props;

  const contextData = useContext(ClientContext);
  const policies = contextData?.policies;
  const showPolicyBanner = useShowPolicyBanner(policies, "home");
  const tenant = config.TENANT;

  const hasPolicyCompliance = listing && "corporateTravel" in listing;

  const isInPolicy = Boolean(
    listing?.corporateTravel?.policyCompliance?.isInPolicy
  );

  const available = listing?.availability?.AvailabilityResult === "Available";

  // Price consistency: prefer the /homes/availability price (honors all-in pricing).
  // Keep the CTA price behind a skeleton until it returns; fall back to the shop
  // price if availability pricing failed (null).
  const priceLoading = listPrice === undefined;
  const availabilityPrice = listPrice ?? listing?.availability.rate?.price;
  // halifax's total-price line ignores `isSkeleton`; pass no price while loading so
  // the shop total can't leak beside the skeleton (the PriceSkeleton covers both rows).
  const showPriceSkeleton = isSkeleton || priceLoading;

  return (
    <Box className="mobile-listing-total-panel">
      {showPolicyBanner && isCorpTenant(tenant) && hasPolicyCompliance && (
        <CorpPolicyBanner
          variant="base"
          productType="home"
          corporateTravel={listing?.corporateTravel}
          limit={policies?.hotels?.policies?.[0]?.maxPricePerNight}
        />
      )}
      <Box
        className={clsx("mobile-listing-total-panel-container", {
          "out-of-policy": hasPolicyCompliance && !isInPolicy,
        })}
      >
        {available ? (
          <>
            <HotelPriceAndRewardsDisplay
              lodgingPrice={showPriceSkeleton ? undefined : availabilityPrice}
              nightCount={nightCount ?? 0}
              isSkeleton={showPriceSkeleton}
              rewardsKey={rewardsKey}
              variant={"default"}
            />
            <ActionButton
              className="b2b"
              onClick={() => {
                goToVacationRentalsCheckout({ history });
              }}
              message={
                <Typography variant="h2" className="button-text">
                  {textConstants.RESERVE_CTA_TEXT}
                </Typography>
              }
            />
          </>
        ) : (
          <>
            <ShopErrorCta variant={IShopErrorCtaVariant.MOBILE_CTA_BUTTON} />
            <ShopErrorButton isMobile={true} />
          </>
        )}
      </Box>
    </Box>
  );
};
